import { PlayerWorkBox, PlayerWorkBoxProps } from "./PlayerWorkBox";
import { MeetingSession, MeetingSessionHighlightingState, MeetingSessionMedia } from "@kalyzee/kast-web-sdk/websocket";
import React from "react";
import { getNormalUser } from "../../helpers/user";


export interface SlavePlayerWorkBoxProps {
  ownSession: MeetingSession;
  children: React.ReactNode;
  meetingOngoing?: boolean;
  session: MeetingSession;
  mediaSession: MeetingSessionMedia;
  topBarMode?: PlayerWorkBoxProps["overlayMode"];
  isSmall?: boolean;
  isPlayingSound?: boolean;
  mediaButtons?: boolean;
  localStream?: boolean;
  boxProps?: PlayerWorkBoxProps["boxProps"];
}

const _SlavePlayerWorkBox: React.FC<SlavePlayerWorkBoxProps> = ({
  ownSession,
  children,
  meetingOngoing,
  session,
  mediaSession,
  topBarMode = "overlay",
  isSmall,
  isPlayingSound,
  mediaButtons,
  localStream,
  boxProps,
}) => {
  const isMe = ownSession?.id === session.id;
  const { displayName, avatar } = session.user ? getNormalUser(session.user) : { displayName: undefined, avatar: undefined };

  const getTopBarLabel = () => {
    if (isMe) return "Vous";
    return displayName ?? "Utilisateur";
  };

  const getTobBarLabelInfo = () => {
    if (isSmall) return undefined;
    let label = mediaSession.extra?.label ?? "webcam";
    return label.charAt(0).toUpperCase() + label.slice(1);
  };

  const videoEnabled = mediaSession.video?.enabled ?? false;
  // Passed on whatever `mediaButtons` says: without the buttons it only feeds
  // the muted-mic indicator, which a secondary screen needs as much as a master.
  const audioEnabled = mediaSession.audio?.enabled ?? false;

  return (
    <PlayerWorkBox
      label={getTopBarLabel()}
      labelInfo={getTobBarLabelInfo()}
      userDisplayName={displayName}
      avatar={avatar}
      userId={session.user?.id}
      overlayMode={topBarMode}
      isScreenSource={mediaSession.extra?.type === "screen"}
      video={mediaButtons ? videoEnabled : undefined}
      audio={audioEnabled}
      isMe={isMe}
      isHighlighted={session.highlighting === MeetingSessionHighlightingState.ONGOING}
      isPlayingSound={isPlayingSound}
      idleAnimation={!meetingOngoing}
      mediaButtons={mediaButtons}
      localStream={localStream}
      boxProps={boxProps}
    >
      {children}
    </PlayerWorkBox>
  );
};

export const SlavePlayerWorkBox = React.memo(_SlavePlayerWorkBox);